import { messagesService } from "@dv5/api"
import { ChangeWidgetData } from "./types"
import { ShapeWidgetData } from "@dv5/domain"

export const useShapeWidgetUpdate = (
    canvasId: string,
    widgetId: string,
    data: ShapeWidgetData
) => {
    const updateData = (patchedPaths: string[], newData: Partial<ShapeWidgetData>) => {
        const updatedData = { ...data, ...newData }
        messagesService.send<ChangeWidgetData>("canvas.change-widget-data", {
            canvasId,
            widgetId,
            patchedPaths,
            data: updatedData as ShapeWidgetData,
        })
    }

    return { updateData }
}
